import React, { useEffect, useState } from "react";
import Card from "src/components/Cards/Basic";
import FabPlateau from "../../../../../components/UiComponents/Buttons/FabPlateau";
import { Dropdown, Spinner } from "react-bootstrap";
import axios from "../../../../../config/axios";
import useModal from "../../../../../components/Modal/hooks/useModal";
import EditHolidayDialog from "./EditHolidayDialog";
import { dateFormatter } from "../../../../../global";
import { showSuccessToast } from "../../../../../components/Toasts";
import ConfirmDeleteDialog from "../../../../../components/Modal/ConfirmDelete";
import ImportHolidaysDialog from "./ImportHolidaysDialog";
import EllipsisDropdown, {
  EllipsisDropdownItem,
  EllipsisDropdownSection,
} from "../../../../../components/EllipsisDropdown";

const Holidays = () => {
  function handleEditHoliday(holiday) {
    setHoliday(holiday);
    toggle();
  }

  function handleCreateHoliday() {
    setHoliday({});
    toggle();
  }

  function handleHolidaySaved() {
    toggle();
    reload();
    showSuccessToast();
  }

  function handleHolidayImportSuccess() {
    toggleImportDialog();
    reload();
    showSuccessToast();
  }

  function handleConfirmDelete() {
    axios.delete(`/api/v1/holidays/${selectedDeleteHoliday.id}.json`).then(
      function () {
        deleteHoliday(selectedDeleteHoliday);
        setSelectedDeleteHoliday(null);
        reload();
        showSuccessToast("Erfolgreich gelöscht");
      },
      function (error) {
        console.log("error ", error.response);
      }
    );
  }
  const { isShow, toggle } = useModal();
  const { isShow: showImportDialog, toggle: toggleImportDialog } = useModal();
  const [holiday, setHoliday] = useState(null);
  const [selectedDeleteHoliday, setSelectedDeleteHoliday] = useState(null);
  const [holidays, setHolidays] = useState([]);

  const [loading, setLoading] = useState(true);

  function reload() {
    setLoading(true);

    axios.get("api/v1/holidays.json").then(({ data }) => {
      setHolidays(data.entries);
      setLoading(false);
    });
  }

  function deleteHoliday(holiday) {
    setLoading(true);

    axios.delete(`api/v1/holidays/${holiday.id}.json`).then(({ data }) => {
      reload();
    });
  }

  useEffect(() => {
    reload();
  }, []);

  return (
    <Card title={"Holidays"}>
      {loading ? (
        <Spinner
          className={"d-block mx-auto"}
          animation="border"
          variant="primary"
        />
      ) : (
        <div className="ui-table-container">
          <table
            className="table table-bordered"
            id="dataTable"
            width="100%"
            cellSpacing="0"
          >
            <thead>
              <tr>
                <th>Bezeichnung</th>
                <th>Zeitraum</th>
                <th>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {!loading &&
                holidays.map((holiday) => (
                  <tr key={holiday.id}>
                    <td>
                      <div className={"d-flex"}>
                        <div
                          className={`rounded-circle mr-2 ui-color-bulb border`}
                          style={{
                            backgroundColor: holiday.color_values.value,
                          }}
                        ></div>
                        {holiday.name}
                      </div>
                    </td>
                    <td>
                      {holiday.from === holiday.to
                        ? dateFormatter(holiday.from)
                        : `${dateFormatter(holiday.from)} - ${dateFormatter(
                            holiday.to
                          )}`}
                    </td>
                    <td>
                      <div className={"d-flex align-items-center"}>
                        <EllipsisDropdown>
                          <EllipsisDropdownSection>
                            <EllipsisDropdownItem
                              onClick={() => handleEditHoliday(holiday)}
                            >
                              Bearbeiten
                            </EllipsisDropdownItem>
                          </EllipsisDropdownSection>
                          <EllipsisDropdownSection>
                            <EllipsisDropdownItem
                              onClick={() => {
                                setSelectedDeleteHoliday(holiday);
                              }}
                            >
                              Löschen
                            </EllipsisDropdownItem>
                          </EllipsisDropdownSection>
                        </EllipsisDropdown>
                      </div>
                    </td>
                  </tr>
                ))}
              {!loading && holidays.length === 0 && (
                <tr>
                  <td colSpan={3}>Keine Einträge vorhanden</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <FabPlateau>
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
            Feiertag hinzufügen
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                toggleImportDialog();
              }}
            >
              Nationalfeiertage importieren
            </Dropdown.Item>
            <Dropdown.Item onClick={handleCreateHoliday}>
              Feiertag hinzufügen
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </FabPlateau>

      {isShow && (
        <EditHolidayDialog
          holiday={holiday}
          handleSuccess={handleHolidaySaved}
          toggle={toggle}
        />
      )}

      {showImportDialog && (
        <ImportHolidaysDialog
          toggle={toggleImportDialog}
          handleSuccess={handleHolidayImportSuccess}
        />
      )}

      <ConfirmDeleteDialog
        show={!!selectedDeleteHoliday}
        handleClose={() => setSelectedDeleteHoliday(null)}
        handleDelete={handleConfirmDelete}
      />
    </Card>
  );
};

export default Holidays;
